<template>
  <div>
    <b-table
      :busy="isLoading"
      :items="listItem"
      :fields="fields"
      bordered
      hover
      class="table-hover"
    >
      <template v-slot:table-busy>
        <vcl-table
          :speed="5"
          :animate="true"
          :columns="10"
        />
      </template>
      <template #cell(sequence)="row">
        {{ listItem.length - row.index }}
      </template>
      <template #cell(id)="row">
        <span
          class="text-primary font-weight-bold cursor-pointer"
          @click="linkToWarranty(row.item.id)"
          >{{ row.item.id }}</span
        >
      </template>
      <template #cell(customerPhone)="row">
        <span class="font-weight-bold">{{ row.item.customerName }}</span>
        <br />
        <span class="text-primary font-weight-bold">{{ row.item.customerPhone }}</span>
      </template>
      <template #cell(warrantyServiceName)="row">
        <span
          v-b-tooltip.hover.top
          :title="row.item.warrantyServiceName"
          >{{ row.item.warrantyServiceName }}</span
        >
      </template>
      <template #cell(imeiCode)="row">
        <span>{{ row.item.productName }}</span>
        <br />
        <span class="text-primary font-weight-bold hover-link">{{ row.item.imeiCode }}</span>
      </template>
      <template #cell(info)="row">
        <ul class="list-unstyled mb-1">
          <li>
            <span class="font-weight-bold">Ngày tiếp nhận:</span>
            {{ row.item.receptionDate }}
          </li>
          <li>
            <span class="font-weight-bold">KTV kiểm tra:</span>
            {{ row.item.inspectedByEmployeeName }}
          </li>
          <li>
            <span class="font-weight-bold">Ghi chú nộ bộ:</span>
            {{ row.item.externalNote }}
          </li>
          <li>
            <span class="font-weight-bold">Mô tả lỗi:</span>
            {{ row.item.externalNote }}
          </li>
          <li>
            <span class="font-weight-bold">Tại:</span>
            {{ row.item.storeName }}
          </li>
        </ul>
      </template>
      <template #cell(statusName)="row">
        <WarrantyStatusBadge
          :status="row.item.status"
          :status-name="row.item.statusName"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import { getWarrantyReceptions } from '../utils/warrantyApi'
import { mapWarrantyListItem } from '../utils/listHelpers'
import { handleError } from '@/utils/common'
import WarrantyStatusBadge from './WarrantyStatusBadge.vue'
import { VclTable } from 'vue-content-loading'

export default {
  name: 'WarrantyImeiHistory',
  components: {
    VclTable,
    WarrantyStatusBadge,
  },
  props: {
    imeiCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      listItem: [],
      totalItems: 0,
      numberOfPage: 1,
      currentPage: 1,
      limit: 10,
      fields: [
        {
          key: 'sequence',
          label: 'Lần',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '5%' },
        },
        {
          key: 'id',
          label: 'ID',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '5%' },
        },
        {
          key: 'warrantyServiceName',
          label: 'Loại dịch vụ',
          sortable: false,
          thStyle: { width: '10%' },
        },
        {
          key: 'imeiCode',
          label: 'Sản phẩm',
          sortable: false,
          thStyle: { width: '20%' },
        },
        {
          key: 'statusName',
          label: 'Trạng thái',
          sortable: false,
          tdClass: 'text-center',
          thStyle: { width: '10%' },
        },
        {
          key: 'customerPhone',
          label: 'Khách hàng',
          sortable: false,
          thStyle: { width: '10%' },
        },
        {
          key: 'info',
          label: 'Thông tin',
          sortable: false,
          thStyle: { width: '30%' },
        },
      ],
    }
  },
  watch: {
    imeiCode: {
      immediate: true,
      handler(val) {
        if (val) this.fetchData()
        else {
          this.listItem = []
          this.totalItems = 0
          this.numberOfPage = 1
        }
      },
    },
  },
  methods: {
    linkToWarranty(id) {
      const routeData = this.$router.resolve({
        name: 'warranty-dispatch-info',
        query: { id },
      })
      window.open(routeData.href, '_blank')
    },
    async fetchData() {
      if (!this.imeiCode || this.imeiCode.trim() === '') return
      this.isLoading = true
      try {
        const params = {
          imeiCode: this.imeiCode.trim(),
          page: this.currentPage,
          limit: this.limit,
        }
        const dataset = await getWarrantyReceptions(params)
        this.totalItems = dataset.totalRow || 0
        this.numberOfPage = dataset.totalPage || 1
        this.listItem = (dataset.dataset || []).map((item) => mapWarrantyListItem(item))
      } catch (err) {
        handleError(err)
        this.listItem = []
      } finally {
        this.isLoading = false
      }
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchData()
    },
  },
}
</script>
